(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rival-brand-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rival-brand-menu')) customElements.define('rival-brand-menu', class extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    const signal = this.controller.signal;
    this.dialog = this.querySelector('dialog');
    this.input = this.querySelector('input');
    this.status = this.querySelector('[role=status]');
    this.list = this.querySelector('.rbm__list');
    this.letter = 'All';
    this.triggers = [...document.querySelectorAll('.header__menu a, #MenuDrawer a.menu-drawer__item-link')].filter(a => new URL(a.href, location.href).pathname.replace(/\/$/, '') === this.dataset.source.replace(/\/$/, ''));
    this.triggers.forEach(a => {
      a.dataset.rivalBrandTrigger = '';
      a.setAttribute('aria-haspopup', 'dialog');
      a.replaceChildren(document.createTextNode('Shop by brand'), this.querySelector('template').content.cloneNode(true));
      a.addEventListener('click', e => { if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return; e.preventDefault(); this.open(a); }, { signal });
    });
    this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close(), { signal });
    this.querySelector('[data-back]').addEventListener('click', () => { this.goBack = true; this.dialog.close(); }, { signal });
    this.dialog.addEventListener('click', e => { if (e.target === this.dialog) { const r = this.dialog.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) this.dialog.close(); } }, { signal });
    this.dialog.addEventListener('keydown', e => { if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); this.dialog.close(); } }, { signal });
    this.dialog.addEventListener('close', async () => {
      document.documentElement.classList.remove('rival-brand-menu-open');
      if (this.goBack && this.drawer?.show) { this.goBack = false; await this.drawer.show(); this.opener.focus(); }
      else if (this.fromMobile) document.querySelector('button[aria-controls="MenuDrawer"]')?.focus();
      else this.opener?.focus();
    }, { signal });
    this.input.addEventListener('input', () => { this.letter = 'All'; this.filter(); }, { signal });
    this.querySelector('[data-clear]').addEventListener('click', () => { this.input.value = ''; this.letter = 'All'; this.filter(); this.input.focus(); }, { signal });
  }
  disconnectedCallback() { this.controller?.abort(); this.controller = null; document.documentElement.classList.remove('rival-brand-menu-open'); }
  async open(opener) {
    this.opener = opener;
    this.drawer = opener.closest('menu-drawer');
    this.fromMobile = !!this.drawer;
    this.querySelector('[data-back]').hidden = !this.fromMobile;
    if (this.drawer?.open && this.drawer.hide) await this.drawer.hide();
    this.dialog.showModal();
    document.documentElement.classList.add('rival-brand-menu-open');
    this.querySelector('[data-close]').focus();
    if (!this.items) await this.load();
  }
  async load() {
    if (this.loading) return;
    this.loading = true;
    this.status.textContent = 'Loading brands…';
    try {
      const response = await fetch(this.dataset.source, { signal: AbortSignal.timeout(15000) });
      if (!response.ok) throw new Error('Unable to load brands');
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      const source = [...page.querySelectorAll('[data-brand-item]')];
      if (!source.length) throw new Error('No brands');
      this.items = source.map(item => {
        const original = item.querySelector('a');
        const name = item.dataset.brandName;
        const url = new URL(original.getAttribute('href'), location.origin);
        if (url.origin !== location.origin) return null;
        const li = document.createElement('li'), a = document.createElement('a'), label = document.createElement('span');
        a.href = url.href; label.dataset.name = ''; label.textContent = name;
        const logo = original.querySelector('.rival-brand-mark')?.cloneNode(true);
        if (logo) a.append(logo);
        a.append(label, this.querySelector('template').content.cloneNode(true)); li.append(a); this.list.append(li);
        const record = { name, a, li, logo, initial: /^[a-z]/i.test(name) ? name[0].toUpperCase() : '#' };
        a.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') this.feature(record); });
        a.addEventListener('focus', () => this.feature(record));
        return record;
      }).filter(Boolean);
      const alphabet = this.querySelector('.rbm__alphabet');
      ['All', '#', ...'ABCDEFGHIJKLMNOPQRSTUVWXYZ'].forEach(letter => {
        const b = document.createElement('button'); b.type = 'button'; b.textContent = letter; b.dataset.letter = letter;
        b.disabled = letter !== 'All' && !this.items.some(x => x.initial === letter);
        b.addEventListener('click', () => { this.input.value = ''; this.letter = letter; this.filter(); }); alphabet.append(b);
      });
      this.filter();
    } catch (error) {
      this.status.textContent = 'The brand list could not load. Use “View all brands” to continue.';
    } finally { this.loading = false; }
  }
  filter() {
    if (!this.items) return;
    const query = this.input.value.trim().toLocaleLowerCase();
    let count = 0;
    this.items.forEach(item => { const visible = item.name.toLocaleLowerCase().includes(query) && (this.letter === 'All' || item.initial === this.letter); item.li.hidden = !visible; if (visible) count++; });
    this.querySelectorAll('[data-letter]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.letter === this.letter)));
    this.querySelector('[data-clear]').hidden = !query && this.letter === 'All';
    this.querySelector('.rbm__empty').hidden = count > 0;
    this.status.textContent = `${count} ${count === 1 ? 'brand' : 'brands'}${this.letter !== 'All' ? ' · ' + this.letter : ''}`;
    this.querySelector('.rbm__results').scrollTop = 0;
  }
  feature(item) {
    const art = this.querySelector('.rbm__feature-art'); art.replaceChildren();
    if (item.logo) art.append(item.logo.cloneNode(true));
    this.querySelector('.rbm__feature-copy h3').textContent = item.name;
    this.querySelector('.rbm__feature-copy p').textContent = 'Explore the range at Rival Performance.';
    const link = this.querySelector('.rbm__feature-copy a'); link.href = item.a.href; link.hidden = false;
    link.setAttribute('aria-label', `Shop ${item.name}`);
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rival-information-page"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rival-info-page')) {
  customElements.define('rival-info-page', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const headings = [...this.querySelectorAll('.rival-info__article h2')];
      const index = this.querySelector('.rival-info__index');
      if (headings.length < 3 || !index) return;
      const list = index.querySelector('ol');
      headings.forEach((heading, i) => {
        heading.id ||= `rival-info-${i + 1}`;
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent;
        link.addEventListener('click', () => {
          list.querySelectorAll('[aria-current]').forEach(x => x.removeAttribute('aria-current'));
          link.setAttribute('aria-current', 'location');
          if (matchMedia('(max-width:767px)').matches) index.open = false;
        });
        item.append(link); list.append(item);
      });
      index.hidden = false;
      const mobile = matchMedia('(max-width:767px)');
      const updateIndex = () => { index.open = !mobile.matches; };
      updateIndex();
      this.indexMedia = mobile;
      this.updateIndex = updateIndex;
      mobile.addEventListener('change', updateIndex);
    }
    disconnectedCallback() {
      this.indexMedia?.removeEventListener('change', this.updateIndex);
      delete this.dataset.ready;
      this.querySelector('.rival-info__index ol')?.replaceChildren();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
